import { Alert, CircularProgress, Snackbar, Tooltip } from '@mui/material';
import Icon from "@mui/material/Icon";
import Vapi from "@vapi-ai/web";
import MDButton from "components/MDButton";
import { useEffect, useState } from 'react';

// Put your Vapi Public Key below.
const vapi = new Vapi(process.env.REACT_APP_VAPI_API_KEY);
const CallButton = ({ agent_api_id, voice_id = null, first_message=null, ...props }) => {
    const [showToast, setShowToast] = useState(false);

    const [isCallInProgress, setIsCallInProgress] = useState(false);
    const [loading, setLoading] = useState(false);
    const handleCall = () => {
        let assistantOverrides = {};
        
        if (voice_id != null) {
            assistantOverrides = {
                voice: {
                    provider: "vapi",
                    voiceId: voice_id
                },
                firstMessage: first_message
            };
        }
        
        if (!isCallInProgress) { // start call
            vapi.start(agent_api_id, assistantOverrides);
        }
        else { //end call
            vapi.stop();
        }
        setIsCallInProgress(!isCallInProgress);
        setLoading(!loading);
    };

    // hook into Vapi events
    useEffect(() => {
        vapi.on("call-start", () => {
            setLoading(false);
        });

        vapi.on("call-end", () => {
            setLoading(false);
            // Call ending, show toast
            setShowToast(true);
            setIsCallInProgress(false);
        });

        vapi.on("speech-start", () => {
            setLoading(false);
        });

        vapi.on("speech-end", () => {
            setLoading(false);
        });

        vapi.on("volume-level", (level) => {
            setLoading(false);
        });

        vapi.on("error", (error) => {
            console.error(error);
            setLoading(false);
        });

        // we only want this to fire on mount
    }, []);

    // Get the tooltip, color, and icon from the map based on the call type
    return (
        <>
            <Tooltip title={isCallInProgress ? (loading ? "Connecting..." : "End Call") : "Talk To Agent"} arrow>
                <MDButton
                    color={isCallInProgress ? "error" : "success"}
                    coloredShadow="info"
                    variant="gradient"
                    size="large"
                    iconOnly
                    circular
                    disabled={loading}
                    onClick={(e) => {
                        e.stopPropagation();
                        handleCall();
                    }}
                    sx={{
                        color: 'white !important',
                        '&:hover': {
                            backgroundColor: '#1662C4',
                        },
                        borderRadius: '50%',
                        p: '0px',
                        ml: 'auto',
                        transition: 'all 0.3s ease',
                        animation: isCallInProgress ? 'bounce 1s infinite' : 'none',
                        '@keyframes bounce': {
                            '0%, 100%': {
                                transform: 'translateY(0)',
                            },
                            '50%': {
                                transform: 'translateY(-5px)',
                            },
                        },
                    }}
                    {...props}
                >
                    {loading ? (
                        <CircularProgress size={24} color="inherit" />
                    ) : (
                        <Icon fontSize="medium">
                            {isCallInProgress ? 'call_end' : 'call'}
                        </Icon>
                    )}
                </MDButton>
                <Snackbar />
            </Tooltip>
            <Snackbar
                open={showToast}
                autoHideDuration={3000}
                onClose={() => setShowToast(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                >
                <Alert severity="info" onClose={() => setShowToast(false)} variant="filled" sx={{fontWeight:'normal'}}>
                    Call ended
                </Alert>
            </Snackbar>
        </>
    );
}

export default CallButton;
